export default "__VITE_ASSET__CIYbASju__"